import { FC } from 'react'
import * as styles from 'components/features/socialFeed/AvatarEditable/AvatarEditable.styl'
import { MemberAvatar } from 'components/features/socialFeed/Avatar/MemberAvatar'

type AvatarEditableProps = {
  actionTitle: string
  onClick?: () => void
}

export const AvatarEditable: FC<AvatarEditableProps> = (props) => {
  const {
    actionTitle,
    onClick,
    children,
  } = props

  return (
    <div
      className={ styles.container }
      data-action-name={ actionTitle }
      onClick={ onClick }
    >
      { !!children && children }
      { !children && (
        <MemberAvatar />
      )}
    </div>
  )
}
